import { render } from "./AdminDashboard.vue?vue&type=template&id=6a7ba75e&scoped=true"
import script from "./AdminDashboard.vue?vue&type=script&lang=js"
export * from "./AdminDashboard.vue?vue&type=script&lang=js"

import "./AdminDashboard.vue?vue&type=style&index=0&id=6a7ba75e&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a7ba75e"]])

export default __exports__